const cn = {
  查看违禁品: '查看违禁品',
  下载图片: '下载图片',
  继续下单: '继续下单',
  下单成功: '下单成功',
  下单失败:'下单失败',
  订单号: '订单号',
  总计: '总计',
  下单: '下单',
  快递信息: '快递信息',
  扫码下单: '扫码下单',
  物品类型: '物品类型',
  物品名称: '物品名称',
  物品信息: '物品信息',
  实际重量: '实际重量',
  '尺寸(CM)': '尺寸(CM)',
  体积重量: '体积重量',
  商品: '商品',
  文件: '文件',
  费用计算如下: '费用计算如下',
  '物品有保价金额,如果发生事故将根据那个保价金额来确定赔偿金额。':
    '物品有保价金额,如果发生事故将根据那个保价金额来确定赔偿金额。',
  '使用J&T保价服务的订单需要支付费用': '使用J&T保价服务的订单需要支付费用',
  '保价费 =': '保价费 =',
  '物品报价金额的1%': '物品报价金额的1%',
  长: '长',
  宽: '宽',
  高: '高',
  驿站寄件: '驿站寄件',
  '计费重量(KG)': '计费重量(KG)',
  快递公司: '快递公司',
  结算方式: '结算方式',
  保价费: '保价费',
  基础运费: '基础运费',
  燃油附加费: '燃油附加费',
  偏远附加费: '偏远附加费',
  超重费: '超重费',
  税金: '税金',
  地址选择: '地址选择',
  请输入搜索关键词: '请输入搜索关键词',
  没有更多了: '没有更多了',
  寄件人信息: '寄件人信息',
  收件人: '收件人',
  阅读并同意: '阅读并同意',
  '《寄件契约条款》': '《寄件契约条款》',
  名称: '名称',
  电话号码: '电话号码',
  详细地址: '详细地址',
  省市区: '省市区',
  声明价值: '声明价值',
  物品金额: '物品金额',
  输入物品金额自动生成: '-',
  请勾选协议: '请勾选协议',
  加载中: '加载中',
  存在必填未填信息: '存在必填未填信息',
  '输入1-3000万的整数': '输入1-3000万的整数',
  寄件契约条款: '寄件契约条款',
  'J&T快递服务协议': 'J&T快递服务协议',
  请选择所在地区: '请选择所在地区',
  请选择快递公司:'请选择快递公司'
}

export default cn
